export const CAREERS = [
  {
    title: "Senior Structural Engineer",
    location: "Shillong / Guwahati",
    type: "Full-time",
    experience: "8+ years",
    description:
      "Lead RCC and steel design for hospitality and infrastructure projects. STAAD/ETABS proficiency required.",
  },
  {
    title: "Project Manager – Infrastructure",
    location: "New Delhi",
    type: "Full-time",
    experience: "10+ years",
    description:
      "Manage government infrastructure programs end-to-end. PMP / PRINCE2 certification preferred.",
  },
  {
    title: "Architect (Hospitality)",
    location: "Guwahati",
    type: "Full-time",
    experience: "5+ years",
    description:
      "Design hotels and resorts from concept through detailed design. Revit fluency required.",
  },
  {
    title: "Site Engineer",
    location: "Dimapur",
    type: "Full-time",
    experience: "3+ years",
    description:
      "Resident site engineer for commercial and retail projects. QA/QC and safety oversight.",
  },
  {
    title: "Survey Engineer",
    location: "Multiple",
    type: "Full-time",
    experience: "4+ years",
    description:
      "Topographical, drone photogrammetry and geotechnical surveys across North-East India.",
  },
  {
    title: "Environmental Consultant",
    location: "New Delhi",
    type: "Full-time",
    experience: "5+ years",
    description:
      "EIA, EMP and IGBC certification advisory for hospitality and infrastructure projects.",
  },
];

export const CULTURE_PILLARS = [
  {
    title: "Engineer with intent",
    body: "Every line on a drawing has a reason. We expect — and reward — engineering judgement, not box-ticking.",
  },
  {
    title: "Own the outcome",
    body: "You will see your project through from feasibility to handover, not just your discipline silo.",
  },
  {
    title: "Climb fast",
    body: "Flat structure, transparent ladders, and project leadership opportunities from year two onwards.",
  },
  {
    title: "Learn relentlessly",
    body: "Sponsored certifications, peer-reviewed design challenges and access to leading international research.",
  },
];

export const BENEFITS = [
  "Competitive compensation with performance bonuses",
  "Health insurance for self and family",
  "Sponsored certifications (PMP, IGBC, PE)",
  "Hybrid working for design roles",
  "Annual offsite and project visits",
  "Wellness and gym allowance",
];
